module.exports = __webpack_public_path__ + "img/list Time off active.b3afc649.svg";